"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useMutation } from "@opensea/graphql";
import { useFileUpload } from "@/hooks/api/use-file-upload";
export const UseCollectionMetadataMediaUploadMutation = graphql(`
  mutation UseCollectionMetadataMediaUpload(
    $slug: String!
    $input: CollectionMetadataUploadInput!
  ) {
    uploadCollectionMetadata(collectionSlug: $slug, input: $input) {
      url
      method
      fields
      token
    }
  }
`);
export function useCollectionMetadataMediaUpload(slug, attribute, t0) {
  const $ = _c(5);
  const section = t0 === undefined ? "OVERVIEW" : t0;
  const [, execute] = useMutation(UseCollectionMetadataMediaUploadMutation);
  let t1;
  if ($[0] !== attribute || $[1] !== execute || $[2] !== section || $[3] !== slug) {
    t1 = {
      getContext: async file => {
        const response = await execute({
          slug,
          input: {
            location: {
              attribute,
              section
            },
            mediaType: file[0].type === "video/mp4" ? "VIDEO" : "IMAGE"
          }
        });
        if (response.error) {
          throw response.error;
        }
        if (!response.data?.uploadCollectionMetadata) {
          return [];
        }
        return [response.data.uploadCollectionMetadata];
      }
    };
    $[0] = attribute;
    $[1] = execute;
    $[2] = section;
    $[3] = slug;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return useFileUpload(t1);
}